import './LandContractTermsPage.css'
import 'antd/dist/reset.css'
import React from 'react'
import LandBottomLayout from '../common/LandBottomLayout'

export default class LandPrivacyPolicyPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div>
        <div className="LandContractTerms">
          <div className="LandContractTermsTitle">隐私政策</div>

          <div className="LandD1">本版更新时间：2023年10月16日</div>

          <div className="LandD">本版生效时间：2023年10月16日</div>

          <div className="LandD">
            上海阿兹尔网络科技有限公司公司（下称“上海阿兹尔”或“我们”）非常重视保护用户的隐私和个人信息，上海阿兹尔也以高度审慎的态度对待本《回答》APP隐私政策（下称“本政策”）下的义务。
          </div>

          <div className="LandD">
            本政策依据中国数据保护相关法律法规制定。本政策中的“个人信息”指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，包括姓名、身份证件号码、通讯地址、住址、账号信息、财产状况、行踪轨迹等。个人信息包括中国数据保护相关法律法规中规定的个人敏感信息。
          </div>

          <div className="LandD">
            本政策与您所使用的《回答》APP与/或其相关服务（下称“产品或服务”）息息相关，在您下载、安装、启动、浏览、注册、登录、使用我们的产品与/或服务时，我们将按照本政策的约定处理和保护您的个人信息，因此我们希望您能够仔细阅读、充分理解本政策的全文，并在需要时，按照本政策的指引，做出您认为适当的选择。本政策涉及的相关技术词汇，我们尽量以简明扼要的表述向您解释，以便于您理解。我们在此善意的提醒您，本政策中与您的权益可能存在重大关系的条款（包括收集、使用您的个人敏感信息类型的情形），请您留意重点查阅。
          </div>

          <div className="LandD">
            您应当在仔细阅读、充分理解本隐私政策后使用我们的产品或服务，如果您不同意本政策的内容，将可能导致我们的产品或服务无法正常运行，或者无法达到我们拟达到的服务效果，您应立即停止访问或使用我们的产品或服务。您使用或继续使用我们提供的产品或服务的行为，都表示您充分理解和同意本政策的全部内容。
          </div>

          <div className="LandD">
            如您在阅读本政策的过程中有任何疑惑，或者您想更详细地了解上海阿兹尔或产品或服务，您可以通过本政策第十一条“如何联系我们”提供的联系方式与我们联系。
          </div>

          <div className="LandB">一、本政策的适用情形</div>

          <div className="LandD">当您使用产品或服务时，本政策即适用。</div>

          <div className="LandB">二 、收集信息的类型</div>

          <div className="LandD">1、我们如何收集和使用您的个人信息</div>

          <div className="LandD">
            您在使用我们的产品或服务时，我们可能需要收集和使用您的一些个人信息，我们收集和使用的您的个人信息类型分为两种：
          </div>

          <div className="LandD">
            一种为核心业务功能所必需的信息：此类信息为产品或服务正常运行的必备信息，您须授权我们收集。如您拒绝提供，您将无法正常使用我们的产品或服务；
          </div>

          <div className="LandD">
            另一种为附加业务功能可能需要收集的信息：此信息为非核心业务功能所需的信息，您可以选择是否授权我们收集。如您拒绝提供，将导致附加业务功能无法实现或无法达到我们拟达到的效果，但不影响您对核心业务功能的正常使用。
          </div>

          <div className="LandD">
            我们需要特别提醒您的是：由于我们的产品和服务较多，为您提供的内容也不同，因此核心业务功能包括其收集的您的个人信息类型也会因产品服务的内容不同而有所区别，具体以产品/服务实际提供为准。除此之外，您理解并同意，我们可能会经常推出新的业务功能，可能需要收集新的个人信息或变更个人信息使用目的或方式。如果某一需要收集您的个人信息的功能或产品/服务未能在本隐私政策中予以说明的，我们会通过更新本政策、页面提示、弹窗、网站公告等方式另行向您说明该信息收集的目的、内容、使用方式和范围，并为您提供自主选择同意的方式，且在征得您明示同意后收集。
          </div>

          <div className="LandD">
            在此过程中，如果您对相关事宜有任何疑惑的，可以通过文末提供的方式联系我们，我们会尽快为您作出解答。
          </div>

          <div className="LandB">
            三、具体的业务功能，及其所对应收集和使用的个人信息类型
          </div>

          <div className="LandD">
            我们收集和使用的您的个人信息类型包括以下：
          </div>

          <div className="LandE">
            <b>
              1、在您注册和登录《回答》APP时，我们会收集您的手机号码、短信验证码。您可以在验证已有的手机号码后，随时修改绑定的登录手机号码。
            </b>
          </div>

          <div className="LandE">
            <b>
              2、在您发起提现时，为了符合国家相关法律法规的要求，我们需要对您进行实名认证。您需要提供您的真实姓名、身份证号码，并通过APP内的人脸识别验证。如果您拒绝提供这些信息，您将无法在《回答》APP里进行提现。
            </b>
          </div>

          <div className="LandD">
            3、在您使用设置功能编辑资料时，您可以根据意愿进一步完善您的档案资料，包括设置和修改头像、昵称。如果您拒绝提供这些信息，不会影响您使用《回答》APP的基本功能。
          </div>

          <div className="LandD">
            4、在您使用设置功能管理账号时，您可以视个人情况选择绑定手机号码。如果您拒绝提供这些信息，不会影响您使用《回答》APP的基本功能。
          </div>

          <div className="LandD">
            5、在某些特殊情况（如协助公安机关或其他国家机关依法履行职务）下，我们可能会请求您提供相关证明的纸质版材料。我们会妥善保管您的纸质版材料，并在目的达成后及时销毁。
          </div>

          <div className="LandD">
            6、当您通过《回答》APP使用我们的服务时，我们会收集一些您使用《回答》APP的数据信息，例如您的点赞、收藏等操作记录、您与其他用户的互动信息，以及访问过的页面或者点击过的链接。收集该等信息可以使我们更好地了解您，比如您来自哪里以及我们的服务有哪些吸引您的内容。我们将该等信息用于内部分析，提升服务质量。
          </div>

          <div className="LandD">
            7、《回答》APP集成并使用了小米，华为，VIVO，OPPO，魅族等手机品牌的官方推送SDK，用于为用户提供信息推送服务。在使用过程中，该SDK会收集：（1）设备参数及系统信息(设备类型、设备型号、系统版本、及相关硬件信息)：用于识别用户的设备类型、设备型号、系统版本等，确保消息准确下发；（2）设备标识符（IMEI、IDFA、Android
            ID、GID、
            MAC、OAID、VAID、AAID、IMSI、MEID、UAID、SN、ICCID、SIM信息）：用于识别唯一用户，保证推送的精准送达及推送信息的准确统计；（3）网络信息(IP
            地址、WiFi
            信息、基站信息、DNS地址、DHCP地址、SSID、BSSID)与位置信息（经纬度）：用于优化SDK与推送服务器的网络连接请求，保证服务的稳定性和连续性，同时实现区域推送功能；（4）推送日志信息：以便开发者查询使用推送服务记录，了解推送信息送达的情况，调整推送策略。
          </div>

          <div className="LandD">
            8、《回答》APP中集成并使用了支付宝SDK（也称阿里巴巴SDK）。该SDK会在您使用支付宝支付功能时请求授权获取您本机的IMEI、IMSI、设备MAC地址信息和SD卡数据信息用于支付安全确认；您可以拒绝授权，并更换其他支付方式（如微信支付），以继续使用相关功能。
          </div>

          <div className="LandD">
            9、《回答》APP中集成的微信开放平台SDK会获取您手机中的应用安装列表，此行为仅仅是为了判断您手机中是否安装了微信APP，以方便在您使用微信支付与提现功能时，能够快速拉起微信APP或者及时提示您手机尚未安装微信APP，而不会用于其他用途（例如保持本应用活跃状态或搜集其他APP相关的隐私信息等等）。
          </div>

          <div className="LandD">
            10、《回答》APP中集成了腾讯Bugly
            SDK。该SDK作用为在APP发生运行异常和闪退崩溃等情形时，及时上报异常和崩溃日志，供开发者迅速发现和解决程序中存在的严重问题，保障用户正常的软件使用体验。
          </div>

          <div className="LandD">11、日志信息</div>

          <div className="LandD">
            我们的日志涉及到的用户信息包括：用户操作系统及版本号、用户终端品牌及型号、用户使用的APP版本号、IP地址、使用时间与使用频率、关键操作路径、错误日志、崩溃记录、时区与语言，设备信息/设备识别码。这些日志信息用来更好地记录我们网站、移动客户端等服务入口的运行状态、了解用户、改善服务，以符合中国法律法规的规定。日志信息不用于识别任何特定的个人。
          </div>

          <div className="LandD">
            例外情形：您充分理解并同意，我们在以下情况下收集、使用您的个人信息无需您的授权同意：
          </div>

          <div className="LandD">（1）与我们履行法律法规规定的义务相关的；</div>

          <div className="LandD">（2）与国家安全、国防安全直接相关的；</div>

          <div className="LandD">
            （3）与公共安全、公共卫生、重大公共利益直接相关的；
          </div>

          <div className="LandD">
            （4）与刑事侦查、起诉、审判和判决执行等直接相关的；
          </div>

          <div className="LandD">
            （5）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您授权同意的；
          </div>

          <div className="LandD">
            （6）所涉及的个人信息是您自行向社会公众公开的；
          </div>

          <div className="LandD">（7）根据您要求签订和履行合同所必需的；</div>

          <div className="LandD">
            （8）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；以及
          </div>

          <div className="LandD">
            （9）维护所提供产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障等。
          </div>

          <div className="LandD">12、设备权限调用</div>

          <div className="LandD">
            为向您提供便捷、优质的服务，我们可能会调用您设备上的一些权限。在您使用相应功能时会看到弹窗提醒，询问您是否授权。您可以在APP或设备的设置功能中选择关闭部分或全部权限。在不同设备中，上述权限的开启和关闭方式可能有所不同，具体请参考设备及系统开发方的说明或指引。
          </div>

          <div className="LandD">操作系统（iOS和安卓）</div>

          <div className="LandD">
            （1）权限：获取手机号。调用权限目的：非用户注册和登陆APP，访问用户手机号，一键登录或者验证码登录
          </div>

          <div className="LandD">
            （2）权限：接收手机短信。调用权限目的：接收短信验证码
          </div>

          <div className="LandD">
            （3）权限：访问手机相册。调用权限目的：更换/上传头像，发布问题或消息回复时发送图片
          </div>

          <div className="LandD">
            （4）权限：录音。调用权限目的：发布问题或消息回复时发送语音
          </div>

          <div className="LandD">
            （5）权限：访问摄像头。调用权限目的：更换/上传头像，发布问题或消息回复时发送图片
          </div>

          <div className="LandD">
            （6）权限：访问麦克风。调用权限目的：发布问题或消息回复时发送语音
          </div>

          <div className="LandD">
            （7）权限：获取手机设备识别号。调用权限目的：发送APP崩溃日志
          </div>

          <div className="LandD">
            我们如在上述场景之外获得您的个人信息，将重新征得您的明示同意，并在获得您明示同意前向您充分说明应用场景与获取您相关信息的内容与范围。
          </div>

          <div className="LandB">四、我们如何使用 Cookie 和同类技术</div>

          <div className="LandD">
            在您使用我们的产品或服务时，我们可能会使用 Cookie
            或同类技术收集您的一些个人信息，包括您的IP地址、设备型号、浏览器型号、大致的地址信息（例如国家或者城市信息）、详细的位置信息以及其他的技术信息。我们也会收集一些您的设备如何与我们的网站互动的信息，例如：访问过的页面或者点击过的链接。Cookie和同类技术收集该等信息是为了在您使用我们的产品与/或服务的过程中，简化您重复操作的步骤（如注册、登录），同时也便于您查看使用历史。我们承诺仅在本政策所述的目的和范围内使用
            Cookie
            和同类技术。您可以通过您的手机的设置全部或部分地拒绝Cookie或同类技术；或删除已经储存在您的计算机内的Cookie或同类技术记录，从而使我们无法追踪您的全部或部分个人信息。在该等情况下，产品或服务中一些用于提供更好浏览体验的功能也将无法使用。
          </div>

          <div className="LandB">
            五、我们如何共享、转让、公开披露您的个人信息
          </div>

          <div className="LandD">（一）共享</div>

          <div className="LandD">
            我们重视对您的个人信息的保护，您的个人信息是我们为您提供产品或服务的重要依据。对于您的个人信息，我们仅在本政策所述的目的和范围内，或根据法律法规的要求收集和使用，并将严格保密。我们可能会将您的个人信息共享给如下种类的第三方：
          </div>

          <div className="LandD">
            （1）向我们的集团公司和为我们公司提供数据处理服务的第三方服务商以及合作伙伴（例如：为了支持产品或服务的正常运营以及安全的服务商，支持我们进行售后服务的合作伙伴和向我们提供信息系统的服务商）进行披露，或者向其他为了本政策所列或者我们在向您收集个人信息时所告知的目的进行数据处理的第三方进行披露；
          </div>

          <div className="LandD">
            （2）向相关的执法机构、监管机构、政府、法院或者其他第三方进行披露，并且该等披露是我们认为必要的，并且是为了（i）符合某一项适用法律法规；（ii）行使、建立或者抗辩我们的合法权利，或者（iii）保护您或者任何其他人的非常重要的权益；
          </div>

          <div className="LandD">
            （3）向与我们业务任何部分的任何拟议的购买、合并或收购有关的潜在买方（及其代理和顾问）进行披露，但我们向该等买方告知其必须仅在本政策披露的目的和范围内使用您的个人信息；以及
          </div>

          <div className="LandD">（4）向您同意的任何其他人进行披露。</div>

          <div className="LandD">
            为向您提供特定的业务和功能，我们的APP可能会接入第三方提供的软件工具开发包（SDK），以向第三方共享您的个人信息。请注意，第三方SDK提供方可能有自己的隐私政策，这些第三方会按照自己的隐私政策来收集和使用您的个人信息而不受本政策的约束。我们会对APP接入的第三方SDK进行安全监测，并努力要求这些提供方按照适用法律法规的要求保护您的个人信息，但建议您查看并阅读他们的隐私政策。关于第三方SDK收集和使用您个人信息的具体情况，请见
            <a
              href="javascript:void(0)"
              style={{ color: '#0463C1' }}
              onClick={() => this.viewThirdPartySDKs()}
            >
              《第三方SDK目录》
            </a>
            。
          </div>

          <div className="LandD">（二）转让</div>

          <div className="LandD">
            转让是指将个人信息控制权向其他公司、组织或个人转移的过程。原则上我们不会将您的个人信息转让，但以下情况除外：
          </div>

          <div className="LandD">（1）您自行提出要求的；</div>

          <div className="LandD">（2）事先已征得您的明示授权同意；以及</div>

          <div className="LandD">
            （3）如果我们进行兼并、收购、重组、分立、破产、资产转让或类似的交易，而您的个人信息有可能作为此类交易的一部分而被转移，我们将要求新持有人继续遵守和履行本政策的全部内容（包括使用目的、使用规则和安全保护措施等）和法律法规的相关规定。如具备上述事由且确需转让的，我们会在转让前按照法律要求向您告知接收方的身份、联系方式等信息。
          </div>

          <div className="LandD">（三）公开披露</div>

          <div className="LandD">
            公开披露是指向社会或不特定人群发布信息的行为。除了因需要对违规账号、欺诈行为等进行处罚公告、公布中奖/获胜者等名单时脱敏展示相关信息等必要事宜而进行的必要披露外，我们不会对您的个人信息进行公开披露，如具备合理事由确需公开披露的，我们会在公开披露前向您告知公开披露的信息的目的、类型（如涉及您的个人敏感信息的，我们还会向您告知涉及的敏感信息的内容），并在征得您的事先明示授权同意后再公开披露，但本政策另有约定的或法律法规另有规定的除外。
          </div>

          <div className="LandD">
            对于公开披露的您的个人信息，我们会充分重视风险，在收到公开披露申请后第一时间且审慎地审查其正当性、合理性和合法性，并在公开披露时和公开披露后采取程度上不低于本政策约定的个人信息安全保护措施对其进行保护。
          </div>

          <div className="LandD">
            请您知悉，即使已经取得您的事先明示授权同意，我们也仅会出于合法、正当、必要、特定、明确的目的公开披露您的个人信息，并尽量对公开披露内容中的个人信息进行去标识化处理。
          </div>

          <div className="LandD">
            我们将严格按照本政策的约定及相关法律法规的要求执行对个人信息的共享、转让、公开披露的操作。
          </div>

          <div className="LandB">六、您的数据主体权利</div>

          <div className="LandD">
            您对我们产品或服务中的您的个人信息享有适用数据保护相关法律法规规定的数据主体权利，包括：您可以访问、更正/修改、删除您的个人信息，也可以撤回之前做出的对您个人信息的明示授权同意，同时您也可以注销您的《回答》APP账号。为便于您行使您的上述数据主体权利，我们在产品或服务的相关页面为您提供了操作指引和操作设置，您可以自行进行操作，如您在操作过程中有疑惑或困难，可以通过第十一条“如何联系我们”提供的联系方式联系我们，我们会及时为您处理。
          </div>

          <div className="LandD">
            我们为您提供账号注销权限，您可以通过在线申请注销、联系我们的客服或通过其他我们公示的方式注销您的账号，一旦您注销账号，将无法使用我们提供的产品或服务，且将自动放弃已有的权益，因此请您谨慎操作。除法律法规另有规定外，注销账号之后，我们将停止为您提供基于该等账号的产品或服务，您曾通过该账号使用的我们的产品与服务的所有内容、信息、数据、记录将会被删除或匿名化处理。
          </div>

          <div className="LandD">
            您有权随时退订我们不时向您发送的营销信息。您可以通过点击每则营销信息中所列的“退订”或者“退出”链接进行退订。如您希望退订其他形式的营销信息（比如通过邮寄或者电话等方式进行的营销），您可以通过第十一条“如何联系我们”提供的联系方式联系我们。
          </div>

          <div className="LandD">
            我们将会按照适用数据保护法律法规的要求回应我们从数据主体收到的行使数据主体权利的请求。
          </div>

          <div className="LandD">
            我们可能无法在如下的情况下回应您的行权请求：
          </div>

          <div className="LandD">
            （1）如果请求的信息与我们履行法律法规规定的义务相关；
          </div>

          <div className="LandD">
            （2）如果请求的信息与国家安全、国防安全直接相关；
          </div>

          <div className="LandD">
            （3）如果请求的信息与公共安全、公共卫生、重大公共利益直接相关；
          </div>

          <div className="LandD">
            （4）如果请求的信息与刑事侦查、起诉、审判和执行判决直接相关；
          </div>

          <div className="LandD">
            （5）如果我们有合理的证据证明您存在主观恶意或者滥用权利；
          </div>

          <div className="LandD">
            （6）出于维护您或者其他个人的生命、财产等重大合法权益但又很难得到您授权同意；
          </div>

          <div className="LandD">
            （7）如果回应您的行权请求会导致您或者其他个人、组织的合法利益受到严重损害；以及
          </div>

          <div className="LandD">（8）如果请求的信息涉及商业秘密。</div>

          <div className="LandB">七、我们如何存储您的个人信息</div>

          <div className="LandD">
            存储地点：我们依照法律法规的规定，将您的个人信息存储于中华人民共和国境内。目前我们暂时不存在跨境存储您的个人信息或向境外提供个人信息的场景。如需跨境存储或向境外提供个人信息的，我们会单独向您明确告知（包括境外接收方的身份、联系方式、处理目的、处理方式、个人信息的种类以及您向境外接收方行使有关数据主体权利的方式等事项）并取得您的单独同意，并将严格要求接收方按照本政策以及其他相关要求来处理您的个人信息。
          </div>

          <div className="LandD">
            存储期限：除法律法规另有规定外，我们将按如下期间存储您的信息：
          </div>

          <div className="LandD">
            （1）我们会储存收集到的您的个人信息以满足我们的正当业务需求（例如向您提供服务或者来满足相应的法律、税务以及财务的要求）。例如：当您使用我们的注册及会员功能时，我们需要收集您的手机号码，且在您提供后（包括在您使用该功能期间），我们需要持续保存您的手机号码，以向您正常提供该功能、保障您的账号和系统安全；以及
          </div>

          <div className="LandD">
            （2）当我们不再需要使用到您的个人信息来满足正当业务需求，或者中国法律法规规定的留存时间届满时，我们会删除您的个人信息或者对其进行匿名化处理，或者在匿名化或者删除皆不可能实现（例如您的个人信息已经在备份中存储）的时候，安全地储存您的这些个人信息并且将这些个人信息与其他的数据处理区隔开来。
          </div>

          <div className="LandB">八、我们如何保护您的个人信息</div>

          <div className="LandD">
            我们一直都极为重视保护用户的个人信息安全，为此我们采用了符合行业标准的安全技术措施及配套的组织架构和管理体系等多层面保护措施，以最大程度降低您的信息被泄露、毁损、误用、非授权访问或非授权披露和更改的风险。我们所采取的措施具体如下：
          </div>

          <div className="LandD">（1）技术措施</div>

          <div className="LandD">
            a）数据安全传输方面，防止传输链路被嗅探、窃听截取的风险，建立安全的隐私数据采集环境，保证数据采集的私密性和完整性；
          </div>

          <div className="LandD">
            b）数据安全存储方面，用户个人敏感信息采取独立、加密存储等额外的安全保护措施；
          </div>

          <div className="LandD">
            c）数据访问和使用的安全控制方面，实施严格的数据权限控制机制，采取多重身份认证技术，并对能够处理您的信息的行为进行监控，避免数据被违规访问和未授权使用；以及
          </div>

          <div className="LandD">
            d）建立完整的审计机制，对数据生命周期的全流程进行监控与审计，防止您的个人信息遭遇未经授权的访问、公开披露、使用、修改、人为或意外的损坏或丢失等。
          </div>

          <div className="LandD">（2）组织和管理措施</div>

          <div className="LandD">
            a）对可能接触到您的信息的工作人员采取最小化权限原则；
          </div>

          <div className="LandD">
            b）建立数据分类分级制度、业务数据安全使用规范、数据合作规范等管理体系，保障您的信息在收集、传输、使用、存储、转移、销毁等环节的处置满足法律法规和相关规范的安全要求；以及
          </div>

          <div className="LandD">
            c）定期组织员工参加安全与隐私保护相关培训并要求员工完成规定的考核，加强员工对于个人信息保护重要性的认识等。
          </div>

          <div className="LandB">九、未成年人保护</div>

          <div className="LandD">
            未成年人使用我们的产品或服务之前应首先取得其监护人的同意。如您为未成年人，在使用我们的产品或服务前，应在监护人的监护、指导下共同阅读本政策，且应在监护人的明示同意和指导下使用我们的产品或服务，或者提交个人信息。我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律法规允许、监护人事先明示同意或保护您的权益所必要的情况下收集、使用或公开披露未成年人的个人信息；若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过第十一条“如何联系我们”提供的联系方式与我们联系。如果我们发现在未事先获得监护人明示同意的情况下收集了未成年人的个人信息，我们会设法尽快删除相关数据。
          </div>

          <div className="LandB">十、隐私政策的更新</div>

          <div className="LandD">
            我们鼓励您在每次使用我们的产品或服务时都查阅我们的隐私政策。为了给您提供更好的服务，我们会根据产品的更新情况及法律法规的要求更新本政策的条款，该等更新构成本政策的一部分。如该等更新造成您在本政策下权利的实质减少或重大变更，我们将在本政策更新生效前通过在显著位置提示，向您发送推送消息或以其他方式通知您，若您继续使用我们的服务，即表示您充分阅读、理解并同意受经修订的隐私政策的约束。为保障您的合法权益，我们建议您定期在设置页面中查看本政策。
          </div>

          <div className="LandB">十一、如何联系我们</div>

          <div className="LandD">
            如您对本政策的执行有任何问题或投诉，或在使用我们的产品或服务时遇到与隐私保护相关的事宜，我们专门为您提供了多种反馈通道，您可在相关页设置中在线提交意见反馈；或者通过邮件反馈：shanghaiazir@126.com。
          </div>

          <div className="LandD">
            我们会在收到您的意见及建议后的15个工作日内完成核查和处理。
          </div>

          <div className="LandB">十二、其他</div>

          <div className="LandD">
            （一）本政策的解释及争议解决均应适用中华人民共和国大陆地区法律。与本政策相关的任何纠纷，双方应协商友好解决；协商不成的，任何一方都有权向上海阿兹尔住所地有管辖权的法院提起诉讼。
          </div>

          <div className="LandD">
            （二）本政策的标题仅为方便阅读而设，并不影响正文中任何规定的含义或解释。
          </div>

          <div className="LandD">公司名称：上海阿兹尔网络科技有限公司</div>

          <div className="LandD">
            注册地址：上海市奉贤区奉浦工业区奉浦大道111号5楼2467室
          </div>

          <div className="LandD">办公地址：上海市浦东新区新德路29号楼201</div>

          <div className="LandD">信息保护负责人联系方式：13162737530</div>
        </div>

        <LandBottomLayout {...this.props} />
      </div>
    )
  }

  viewThirdPartySDKs = () => {
    this.props.history.push('/thirdparty_sdks')
  }
}
